import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.966 11.877a5.21 5.21 0 0 0-.204-4.144 5.37 5.37 0 0 0-3.053-2.63 4.71 4.71 0 0 0-9.341 0 5.24 5.24 0 0 0-3.093 2.614 5.39 5.39 0 0 0-.212 4.152 5.07 5.07 0 0 0-.589 5.165 5.3 5.3 0 0 0 3.674 2.826.4.4 0 0 0 .141 0h3.925v2.355a.785.785 0 1 0 1.57 0V19.86h3.925a.4.4 0 0 0 .141 0 5.3 5.3 0 0 0 3.713-2.794 5.06 5.06 0 0 0-.597-5.189m-.832 4.514a3.65 3.65 0 0 1-2.504 1.9h-3.846v-5.22l2.967-3.706a.785.785 0 1 0-1.224-.98l-1.743 2.173V6.516a.785.785 0 1 0-1.57 0v7.967L9.471 12.31a.785.785 0 1 0-1.224.981l2.967 3.705v1.295H7.368a3.65 3.65 0 0 1-2.504-1.9 3.525 3.525 0 0 1 .651-3.854.785.785 0 0 0 .118-.879 3.8 3.8 0 0 1 0-3.218 3.8 3.8 0 0 1 2.583-1.923.785.785 0 0 0 .643-.785 3.14 3.14 0 0 1 6.28 0 .785.785 0 0 0 .644.785 3.8 3.8 0 0 1 2.582 1.939 3.8 3.8 0 0 1 0 3.218.785.785 0 0 0 .118.88 3.53 3.53 0 0 1 .651 3.838"
    }, null, -1)
  ]))]))
}
export default { render: render }